/*
** $Id$
**
** Copyright 2018 Port25 Solutions, Inc.
** All rights reserved.
*/


import React from 'react';
import { Link } from 'react-router-dom';
var homepage = require('../../package.json').homepage;


/**
 * Provides helper functions to format links for navigation across pages.
 */
export default class LinkFormatter {
    constructor(props) {
        this.linkVmta = this.linkVmta.bind(this)
    }


    /**
     * Links the given virtual MTA.
     *
     * @param name
     *      name of the virtual MTA to link
     * @return
     *      a 'Link' component that redirects to virtual MTA detail.
     */
    linkVmta(vmta) {
        return <Link to={`${homepage}/queues/*/${vmta}`}>{vmta}</Link>
    }


    /**
     * Links the given domain.
     *
     * @param name
     *      name of the domain to link
     * @return
     *      a 'Link' component that redirects to domain detail.
     */
    linkDomain(domain) {
        return <Link to={`${homepage}/domainDetail/${domain}`}>{domain}</Link>
    }
}


export let linkFormatter =  new LinkFormatter()
